import React, { useEffect, useState } from 'react';
import styled from 'styled-components';


const SpanPckgNavPriceBlock = styled.p`
    font-size: ${props => props.fontSize || '26px'};
    font-weight: ${props => props.fontWeight || '500'};
    float: ${props => props.float || 'right'};
    text-decoration: ${props => props.isSale ? 'line-through' : ''}; 
    color: ${props => props.isDisable ? '#bbbbbb': (props.isSale ? '#999999' : '#111111')}; 
`;

const SpanNumberBlock = styled.span`
    font-family: Montserrat,sans-serif;
    font-weight: ${props => props.fontWeight || '700'};;
`;

const SpanPckgNavPrice = ({ value, fontSize, fontWeight, float, wonFontSize = '18px', isSale=false, isDisable=false }) => {

    return (
        <SpanPckgNavPriceBlock fontSize={fontSize} fontWeight={fontWeight} float={float} isSale={isSale} isDisable={isDisable}>
            <SpanNumberBlock fontWeight={fontWeight}>{Number((value * 1).toFixed(1)).toLocaleString()}</SpanNumberBlock>
            <span style={{ fontSize: wonFontSize, fontWeight: '400' }}>원</span>
        </SpanPckgNavPriceBlock>
    );
};

export default SpanPckgNavPrice;